import { useCallback } from 'react';

import { loadScript } from 'common/utils/utils';

const useMetaPixel = () => {
  const initMetaPixel = useCallback(pixelId => {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;

    window.fbq = (...args) => {
      if (window.fbq.callMethod) {
        window.fbq.callMethod(...args);
      } else {
        window.fbq.queue.push(args);
      }
    };

    window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = true;
    window.fbq.version = '2.0';
    window.fbq.queue = [];

    loadScript('https://connect.facebook.net/en_US/fbevents.js').catch(() => {});

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }, []);

  const trackEvent = useCallback((event, data = {}) => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', event, data);
    }
  }, []);

  return { initMetaPixel, trackEvent };
};

export default useMetaPixel;
